import { z } from "zod";

export const contentNames = [
  "AccountSmall",
  "CommittedDatabase",
  "FussyAttestation",
  "PointReport",
  "QuestLog",
  "QuestMemory",
  "RadioResponseMemory",
  "MembershipShortcut",
] as const;

export const contentNameSchema = z.enum(contentNames);

export type ContentName = z.infer<typeof contentNameSchema>;
